import React from 'react';
import { Box, Divider, Flex } from '@chakra-ui/react';
import { useIsMobile } from '#hooks/useIsMobile';

const MARGIN_X = 16;

export const ContentContainer = ({
  children,
  topContent = null,
  sidebarWidth = 250,
}) => {
  const isMobile = useIsMobile();
  const desktopWidth = `calc(min(1000px, 100% - ${sidebarWidth}px - ${2 * MARGIN_X}px))`;
  const sidebarSpacing = <Box aria-label="sidebarSpacing" width={sidebarWidth} />;

  return (
    <>
      {isMobile ? null : sidebarSpacing}
      <Box
        width={{ base: '100%', md: desktopWidth }}
        maxWidth={{ base: '100%', md: desktopWidth }}
        marginX="auto"
        paddingX={{ base: 4, md: 0 }}
        paddingBottom={4}
      >
        <Flex
          height={8}
          direction="row"
          alignItems="center"
          marginY={4}
        >
          {topContent}
        </Flex>
        <Divider marginTop="-1px" />
        <Box with="full" marginTop={8}>
          {children}
        </Box>
      </Box>
    </>
  );
};
